console.log('js caricato')

document.addEventListener('DOMContentLoaded', function() {
  // Attendo mezzo secondo prima di eseguire
  setTimeout(function() {
    const detailsEl = document.querySelector('details.js-details-filter[data-index="1"]');
    if (detailsEl) {
      detailsEl.removeAttribute('open');
      detailsEl.classList.remove('is-open');
    }
  }, 500); // <-- qui imposti il delay in millisecondi
});

